module.exports = __webpack_public_path__ + "media/images/icon_arrow_back-0b2a4a4e01d7e675a4939c637c139448.png";